/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}


// function test(a){
//   let testAddCart = a.parentElement.parentElement.parentElement.querySelector('.test__add_qty');
// }

Shopify.addItem = function(variant_id, quantity, callback){
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// CUSTOM PREORDER DEPOSIT START
var CELLBAY_PREORDER_DEPOSIT_VARIANT_ID = '54436325753196';
var CELLBAY_PREORDER_DEPOSIT_CENTS = 10000;
var CELLBAY_PREORDER_PROPERTY_NAMES = [
  'properties[Note]',
  'properties[Original Product Title]',
  'properties[Original Product ID]',
  'properties[Original Variant ID]',
  'properties[Original Variant Title]',
  'properties[Original SKU]',
  'properties[Original selected options]',
  'properties[Original Full Price]',
  'properties[Deposit Paid]',
  'properties[Remaining Balance]'
];

function cellbayPreorderFormFields(form_id) {
  return jQuery('#' + form_id).serializeArray();
}

function cellbayPreorderFieldValue(fields, name) {
  for (var i = 0; i < fields.length; i++) {
    if (fields[i].name === name) {
      return fields[i].value;
    }
  }
  return '';
}

function cellbayPreorderMoney(cents) {
  return Shopify.formatMoney(cents, window.money_format);
}

function cellbayPreorderMetadata(formFields) {
  var product = window.CellbayPreorderProductData;
  var variantId = cellbayPreorderFieldValue(formFields, 'id');
  var variant = null;

  if (product && product.variants) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        variant = product.variants[i];
        break;
      }
    }
  }

  if (!product || !variant || variant.price === undefined || variant.price === null) {
    return null;
  }

  var originalPriceCents = Number(variant.price);
  if (!isFinite(originalPriceCents) || originalPriceCents < 0) {
    return null;
  }
  originalPriceCents = Math.round(originalPriceCents);

  var selectedOptions = variant.options && variant.options.length ?
    variant.options.join(' / ') : variant.title;

  return {
    productTitle: product.title || '',
    productId: product.id || '',
    variantId: variant.id || variantId,
    variantTitle: variant.title || selectedOptions || '',
    sku: variant.sku || '',
    selectedOptions: selectedOptions || '',
    originalPrice: cellbayPreorderMoney(originalPriceCents),
    depositPaid: cellbayPreorderMoney(CELLBAY_PREORDER_DEPOSIT_CENTS),
    remainingBalance: cellbayPreorderMoney(Math.max(0, originalPriceCents - CELLBAY_PREORDER_DEPOSIT_CENTS))
  };
}

function cellbayPreorderPayload(formFields, metadata) {
  var fields = [];
  var preservedPropertyFields = [];

  for (var i = 0; i < formFields.length; i++) {
    if (formFields[i].name.indexOf('properties[') === 0 &&
        CELLBAY_PREORDER_PROPERTY_NAMES.indexOf(formFields[i].name) === -1) {
      preservedPropertyFields.push(formFields[i]);
    }
  }

  for (var j = 0; j < preservedPropertyFields.length; j++) {
    fields.push(preservedPropertyFields[j]);
  }

  // Preserve Essential Preorder and any other existing line item properties.
  var note = cellbayPreorderFieldValue(formFields, 'properties[Note]');
  fields.push({ name: 'properties[Note]', value: note || 'Preorder' });
  fields.push({ name: 'properties[Original Product Title]', value: metadata.productTitle });
  fields.push({ name: 'properties[Original Product ID]', value: metadata.productId });
  fields.push({ name: 'properties[Original Variant ID]', value: metadata.variantId });
  fields.push({ name: 'properties[Original Variant Title]', value: metadata.variantTitle });
  fields.push({ name: 'properties[Original SKU]', value: metadata.sku });
  fields.push({ name: 'properties[Original selected options]', value: metadata.selectedOptions });
  fields.push({ name: 'properties[Original Full Price]', value: metadata.originalPrice });
  fields.push({ name: 'properties[Deposit Paid]', value: metadata.depositPaid });
  fields.push({ name: 'properties[Remaining Balance]', value: metadata.remainingBalance });
  fields.push({ name: 'id', value: CELLBAY_PREORDER_DEPOSIT_VARIANT_ID });
  fields.push({ name: 'quantity', value: '1' });

  return jQuery.param(fields);
}

function cellbayPreorderMissingDataError(errorCallback) {
  var xhr = {
    status: 422,
    responseText: JSON.stringify({
      message: 'Preorder information is unavailable.',
      status: 422,
      description: 'Please refresh the product page and try again.'
    })
  };

  if (typeof errorCallback === 'function') {
    errorCallback(xhr, 'error');
  } else {
    Shopify.onError(xhr, 'error');
  }
}

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
  var formFields = cellbayPreorderFormFields(form_id);
  var isPreorder = cellbayPreorderFieldValue(formFields, 'properties[Note]') === 'Preorder';
  var preorderMetadata = isPreorder ? cellbayPreorderMetadata(formFields) : null;

  if (isPreorder && !preorderMetadata) {
    cellbayPreorderMissingDataError();
    return;
  }

  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function() {
      if (form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: isPreorder ? cellbayPreorderPayload(formFields, preorderMetadata) : jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function() {
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
        setTimeout(function() {
          jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
      Shopify.onItemAdded(line_item);
    }
  };
  jQuery.ajax(params);
};
// CUSTOM PREORDER DEPOSIT END

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("data-srcset");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
   // var propPrice = jQuery('#product_current_price').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').html(title);  
    //jQuery('.pop_current_price').text('"'+ propPrice +'"');
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').html(title); 
	jQuery('#modalAddToCart').modal("toggle");
}

// CUSTOM PREORDER DEPOSIT START
function cellbayPreorderEscapeHtml(value) {
  return jQuery('<div>').text(value || '').html();
}

function cellbayPreorderCartMarkup(item, formatMoney) {
  var properties = item.properties || {};
  var originalTitle = properties['Original Product Title'];
  var isPreorderDeposit = properties.Note === 'Preorder' && originalTitle;

  if (!isPreorderDeposit) {
    return '';
  }

  var selectedOptions = properties['Original selected options'] || properties['Original Variant Title'] || '';
  var fullPrice = properties['Original Full Price'] || '';
  var depositPaid = properties['Deposit Paid'] || Shopify.formatMoney(item.price, formatMoney);
  var remainingBalance = properties['Remaining Balance'] || '';
  var image = cellbayPreorderEscapeHtml(item.image || '');
  var url = cellbayPreorderEscapeHtml(item.url || '#');
  var title = cellbayPreorderEscapeHtml(originalTitle);
  var options = cellbayPreorderEscapeHtml(selectedOptions);
  var full = cellbayPreorderEscapeHtml(fullPrice);
  var deposit = cellbayPreorderEscapeHtml(depositPaid);
  var remaining = cellbayPreorderEscapeHtml(remainingBalance);

  return '<div class="single-cart-product single-cart-product--preorder">' +
    '<span class="cart-close-icon"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="ti-close"></i></a></span>' +
    '<div class="image"><a href="' + url + '"><img src="' + image + '" class="img-fluid" alt=""></a></div>' +
    '<div class="content"><h5><span class="preorder-product-title">' + title + '</span></h5>' +
    (options ? '<p class="preorder-product-variant">' + options + '</p>' : '') +
    '<p class="preorder-product-summary"><span>Full Price: ' + full + '</span><br>' +
    '<span>Preorder Deposit Due Now: ' + deposit + '</span><br>' +
    '<span>Remaining Balance: ' + remaining + '</span></p></div></div>';
}
// CUSTOM PREORDER DEPOSIT END

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count,.cart-product-wrapper").css({"display": "block"});
            jQuery(".single-cart-product.empty , .item-single-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              var preorderMarkup = cellbayPreorderCartMarkup(item, formatMoney);
              if (preorderMarkup) {
                jQuery(preorderMarkup).appendTo(table);
              } else {
                jQuery('<div class="single-cart-product"> <span class="cart-close-icon"> <a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="ti-close"></i></a> </span><div class="image"> <a href="' + item.url + '"> <img src="' + item.image + '" class="img-fluid" alt=""> </a></div><div class="content"><h5><a href="' + item.url + '">' + item.title + '</a></h5><p><span class="cart-count">' + item.quantity + ' x </span> <span class="discounted-price">' + Shopify.formatMoney(item.price, formatMoney) + '</span></p></div></div>').appendTo(table);
              }
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count,.cart-product-wrapper").css({"display": "none"});
            jQuery(".single-cart-product.empty").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
